import m from "mithril";
import i18n from "../../../shared/i18n/i18n";
import Component_Unit_Assessment_Settings from "./component_unit_assessment_settings";
import Component_Unit_Assessment_Editor from "./component_unit_assessment_editor";
import Unit_Courses from "../unit_courses";

const Page_Unit_Assessment = {
    loading: false,
    tab: "editor",
    unit: null,

    oninit(vnode) {
        this.unit = vnode.attrs.unit;
    },

    setTab(newTab) {
        if (this.tab !== newTab) {
            this.tab = newTab;
            m.redraw();
        }
    },

    view() {
        const { loading, tab, unit } = this;

        // Toolbar menu tabs
        const tabItems = [
            { id: "editor", label: i18n.t("editor") },
            { id: "settings", label: i18n.t("settings") },
            { id: "courses", label: i18n.t("courses") }
        ];

        return m(".page-unit-assessment", [
            m(".content-box", [
                m(".toolbar", { class: loading ? "disable-buttons" : "", role: "tablist" }, [
                    m(".toolbar-section.with-menu", [
                        m("h1", i18n.t("assessment_unit")),
                        m(
                            ".toolbar-menu",
                            tabItems.map(({ id, label }) =>
                                m(
                                    "div",
                                    {
                                        role: "tab",
                                        tabindex: 0,
                                        class: id === tab ? "active" : "",
                                        onclick: () => this.setTab(id),
                                        onkeypress: (e) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                                this.setTab(id);
                                            }
                                        },
                                    },
                                    label
                                )
                            )
                        )
                    ])
                ]),
            ]),

            !loading
                ? unit
                    ? tab === "editor"
                        ? m(Component_Unit_Assessment_Editor, { unit })
                        : tab === "settings"
                            ? m(Component_Unit_Assessment_Settings, { unit: unit.properties, onCoursesClick: () => this.setTab("courses") })
                            : tab === "courses"
                                ? m(Unit_Courses, { unitId: unit.properties.id })
                                : null
                    : m(".text-gray.padding", i18n.t("unable_to_load_unit"))
                : m(".text-gray.padding", [i18n.t("loading"), m(".loading-dots")]),
        ]);
    },
};

export default Page_Unit_Assessment;
